import angular from "angular";

angular
	.module('app')
	.component('applicationsReport', {
		template: require('./applications-report.html'),
        controller: ['$http', 'moment', '$httpParamSerializer', controller],
        bindings: {
        }
    });

function controller($http, moment, $httpParamSerializer) {

	let $ctrl = this;

    $ctrl.startDate = null;
    $ctrl.endDate = null;

	$ctrl.selectedBranch = null;
	$ctrl.branches = [];

	$ctrl.$onInit = function () {

    };

    $ctrl.getList = () => {

        if (!$ctrl.startDate) {
            alert('Период не выбран');
            return;
        }

        const url = '/reports/get-list';

        const params = {
            start_date: moment($ctrl.startDate).format('YYYY-MM-DD'),
            end_date: $ctrl.endDate ? moment($ctrl.endDate).format('YYYY-MM-DD') : null,
        }

        $ctrl.exportUrlParams = $httpParamSerializer(params);

        $ctrl.loading = true;

        $http
            .post(url, params)
            .then(
                (res) => {
                    $ctrl.loading = false;
                    $ctrl.branches =  res.data.branches;
                    $ctrl.branchesTotal = res.data.branchesTotal;
                    $ctrl.selectedBranch = null;
                },
                (error) => {
                    $ctrl.loading = false;

                    let checked = false;
                    let message = '';

                    angular.forEach(error.data.errors, function (value, key){
                        if (!checked) {
                            message += value[0];
                            checked = true;
                        }
                    });

                    if (message.length) {
                        window.Swal.fire({
                            icon: 'error',
                            title: message,
                        })
                    } else {
                        alert("Не известная ошибка обратитесь к администраций сайта");
                    }
                }
            );
    }

	$ctrl.selectBranch = (index) => {
	    $ctrl.selectedBranch = $ctrl.branches[index];
    }

    $ctrl.unSelectBranch = () => {
	    $ctrl.selectedBranch = null;
    }

    $ctrl.openCar = (id) => {
	    window.location = '/cars/' + id + '/history/applications';
    }
}
